module.exports = __webpack_public_path__ + "img/4.490f5c76.jpg";